import { Box, CircularProgress, Typography, useTheme } from '@mui/material';
import React, { useCallback, useMemo } from 'react';

import { WIDTH_MODAL_COMPONENTS } from '../../../../constants/addressBook';
import NotificationAlert, { AlertDescription, AlertTitle } from '../../../_mui/_alerts_/NotificationAlert';
import { useUploadModal } from '../UploadModalContext';

interface IProps {
  closeModal: () => void;
}

const ImportAddressesStep: React.FC<IProps> = ({ closeModal }) => {
  const theme = useTheme();

  const { isLoading, handleCloseWithSuccess, successLabel, profile } = useUploadModal();
  const importSuccessAlert = profile.copy.importSuccessAlert;

  const handleAlertButton = useCallback(() => {
    handleCloseWithSuccess(closeModal);
  }, [closeModal, handleCloseWithSuccess]);

  const centeredContentStyle = useMemo(
    () => ({
      width: '100%',
      height: '100%',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    }),
    [],
  );

  return (
    <>
      <Box sx={centeredContentStyle}>
        {isLoading ? (
          <Box
            sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', gap: 2 }}
          >
            <CircularProgress size="3rem" sx={{ color: theme.sass.globalAccentColor }} />
            <Typography variant="body1">Importing your file. Please wait</Typography>
          </Box>
        ) : (
          <Box sx={{ width: WIDTH_MODAL_COMPONENTS }}>
            <NotificationAlert
              type={importSuccessAlert.type}
              actionButtonText={importSuccessAlert.buttonText}
              actionOnClick={handleAlertButton}
              actionSx={{ padding: '4px 0 0 5px', justifyContent: 'flex-end' }}
            >
              <AlertTitle>{importSuccessAlert.title(successLabel)}</AlertTitle>
              <AlertDescription>{importSuccessAlert.description}</AlertDescription>
              <AlertDescription>{importSuccessAlert.amountOfAddresses(successLabel)}</AlertDescription>
            </NotificationAlert>
          </Box>
        )}
      </Box>
    </>
  );
};

export default ImportAddressesStep;
